import React, { useState } from 'react';
import { Accordion, Button, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { MODULE } from 'Constants/General';
import useTranslation from 'Hooks/useTranslation';
import { Apps, ExpandMore } from '@mui/icons-material';
import Lesson from '../Lesson';
import SelectLesson from '../selecLesson';
import { drawerBottomButton, iconStyle, typographyStyle, acordionStyle } from './style';

export default function Module({
  modules,
  position,
  setCurrentPositionModule = () => {},
  setTypeContent,
  currentPositionLesson,
  setCurrentPositionLesson,
}) {
  const { t2 } = useTranslation('EditCourse');
  const [isOpen, setIsOpen] = useState(false);
  const [expand, setExpand] = useState(false);

  const module = modules[position];
  const draggableId = module?.id || position;

  const toggleAcordion = () => {
    setExpand(!expand);
    setIsOpen(false);
    setCurrentPositionModule(position);
    setTypeContent(MODULE);
  };

  const handleClick = () => {
    setIsOpen(true);
  };

  return (
    <Draggable key={draggableId} draggableId={draggableId} index={position}>
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <Accordion style={{ marginTop: '1rem' }} expanded={expand}>
            <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" onClick={toggleAcordion}>
              <div {...provided.dragHandleProps}>
                <Apps style={iconStyle} />
              </div>
              <Typography style={typographyStyle}>{module?.name}</Typography>
            </AccordionSummary>
            <Droppable key={draggableId} droppableId={`droppable-lessons-${draggableId}`} type={position}>
              {provided2 => (
                <div ref={provided2.innerRef}>
                  {module.lessons
                    ? module.lessons.map((lesson, j) => (
                        <Lesson
                          key={j}
                          lesson={lesson}
                          index={j}
                          positionModule={position}
                          setCurrentPositionModule={setCurrentPositionModule}
                          currentPositionLesson={currentPositionLesson}
                          setCurrentPositionLesson={setCurrentPositionLesson}
                          setTypeContent={setTypeContent}
                        />
                      ))
                    : null}
                  {provided2.placeholder}
                </div>
              )}
            </Droppable>
            {isOpen ? (
              <SelectLesson
                onCancel={setIsOpen}
                onSelect={setTypeContent}
                module={module}
                setCurrentPositionLesson={setCurrentPositionLesson}
              />
            ) : null}
            <AccordionDetails style={acordionStyle}>
              {isOpen ? null : (
                <Button variant="contained" style={drawerBottomButton} onClick={handleClick}>
                  {t2('AddLesson')}
                </Button>
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      )}
    </Draggable>
  );
}
